"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _reactComponents = require("@cimpress/react-components");

var _sharedtypes = require("../../shared/sharedtypes");

var SelectedConfigurationDisplay = function SelectedConfigurationDisplay(_ref) {
  var selectedFulfillmentConfiguration = _ref.selectedFulfillmentConfiguration,
      clearSelectedFulfillmentConfiguration = _ref.clearSelectedFulfillmentConfiguration,
      showFulfillmentConfigurationsList = _ref.showFulfillmentConfigurationsList,
      clearSelectedVersion = _ref.clearSelectedVersion,
      onFulfillmentConfigurationSelected = _ref.onFulfillmentConfigurationSelected;

  var _useTranslation = (0, _reactI18next.useTranslation)('selectedConfigurationDisplay'),
      t = _useTranslation.t;

  var selectedConfigurationDisplayText = selectedFulfillmentConfiguration ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-selectedConfigurationDisplay__hasSelectedText"
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('selectedConfigurationLabel')), /*#__PURE__*/_react["default"].createElement("span", null, selectedFulfillmentConfiguration.fulfillmentConfigurationName)) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "fcp-selectedConfigurationDisplay__selectionPrompt"
  }, t('noSelectedConfigurationLabel'));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-selectedConfigurationDisplay"
  }, selectedConfigurationDisplayText, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    disabled: !selectedFulfillmentConfiguration,
    onClick: function onClick() {
      clearSelectedFulfillmentConfiguration();
      clearSelectedVersion();
      showFulfillmentConfigurationsList();
      onFulfillmentConfigurationSelected({
        fulfillmentConfigurationUrl: ''
      });
    }
  }, t('clearButton'))));
};

SelectedConfigurationDisplay.propTypes = {
  selectedFulfillmentConfiguration: _sharedtypes.FulfillmentConfiguration,
  clearSelectedFulfillmentConfiguration: _propTypes["default"].func.isRequired,
  showFulfillmentConfigurationsList: _propTypes["default"].func.isRequired,
  clearSelectedVersion: _propTypes["default"].func.isRequired,
  onFulfillmentConfigurationSelected: _propTypes["default"].func.isRequired
};
SelectedConfigurationDisplay.defaultProps = {
  selectedFulfillmentConfiguration: undefined
};
var _default = SelectedConfigurationDisplay;
exports["default"] = _default;